import { render } from "./ModalInfoAward.vue?vue&type=template&id=4856c7a6&scoped=true"
import script from "./ModalInfoAward.vue?vue&type=script&lang=js"
export * from "./ModalInfoAward.vue?vue&type=script&lang=js"

import "./ModalInfoAward.vue?vue&type=style&index=0&id=4856c7a6&scoped=true&lang=css"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4856c7a6"]])

export default __exports__